import { z } from 'zod';
import { MoneySchema } from './common.js';
export const ProjectTypeSchema = z.enum(['CIP', 'SALES', 'COST_CENTER']);
export const ProjectSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    code: z.string().min(1).max(64),
    nameTh: z.string().min(1),
    type: ProjectTypeSchema,
    branchId: z.uuid().nullable().optional(),
    pm: z.string().nullable().optional(),
    // Prisma Decimal(18,2): accept either the canonical string form (MoneySchema)
    // or a non-negative number that we coerce — both serialize cleanly into Prisma.
    budget: z.union([MoneySchema, z.coerce.number().nonnegative()]),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateProjectSchema = ProjectSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateProjectSchema = CreateProjectSchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=project.js.map